const PROGRAMMATIC_BROWSER_NAVIGATION_TTL_MS = 1_000;

let programmaticBrowserNavigationMarkedAt: number | null = null;

export const markNextBrowserNavigationAsProgrammatic = () => {
    programmaticBrowserNavigationMarkedAt = Date.now();
};

export const consumeProgrammaticBrowserNavigation = (): boolean => {
    if (programmaticBrowserNavigationMarkedAt === null) return false;

    const markedAt = programmaticBrowserNavigationMarkedAt;
    programmaticBrowserNavigationMarkedAt = null;

    return Date.now() - markedAt <= PROGRAMMATIC_BROWSER_NAVIGATION_TTL_MS;
};
